"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReportOptionSlideContainerPane;
(function (ReportOptionSlideContainerPane) {
    ReportOptionSlideContainerPane[ReportOptionSlideContainerPane["OptionForm"] = 1] = "OptionForm";
    ReportOptionSlideContainerPane[ReportOptionSlideContainerPane["EmailOptions"] = 2] = "EmailOptions";
})(ReportOptionSlideContainerPane || (ReportOptionSlideContainerPane = {}));
;
exports.default = ReportOptionSlideContainerPane;
